import { createFileRoute } from "@tanstack/react-router";
import { FractionalCmoB2cEcommerce, b2cPage, specialistServiceSchema } from "@/pages/SpecialistCmoPages";
import { faqSchema, pageHead } from "@/lib/seo";

export const Route = createFileRoute("/fractional-cmo-b2c-ecommerce")({
  head: () =>
    pageHead({
      path: b2cPage.path,
      title: b2cPage.title,
      description: b2cPage.description,
      crumbs: [["Fractional CMO B2C & E-commerce", "/fractional-cmo-b2c-ecommerce"]],
      schemas: [...specialistServiceSchema(b2cPage), faqSchema(b2cPage.faq)],
    }),
  component: FractionalCmoB2cEcommerce,
});
